module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ContactBoxImage":{"alt":"Obrázek potřebujete pomoci?"}}}')
  delete Component.options._Ctor
}
